module.exports = __webpack_public_path__ + "img/partners_tami.740c65a6.png";